<template>
  <div class="search-result-container">
    <div class="main">
        <div class="tool-wrap">
            <div class="tabs-box">
                <div
                class="tabs-item"
                v-for="(item, index) in tabs"
                :key="index"
                :class="[item.value == current_tab ? 'active' : '']"
                @click="current_tab = item.value"
                >
                {{ item.name }}
                </div>
            </div>
            <Poptip trigger="hover" placement="bottom-end" width="180px">
                <template #content>
                    <div @click="query.sort='complex'" class="sort-item">综合排序 <Icon v-if="query.sort == 'complex'" type="md-checkmark"></Icon></div>
                    <div @click="query.sort='time'" class="sort-item">时间排序 <Icon v-if="query.sort == 'time'" type="md-checkmark"></Icon></div>
                </template>
                <div class="sort-box">
                    {{ query.sort == 'complex' ? '综合排序' :'时间排序' }}<Icon type="md-arrow-dropdown"></Icon>
                </div>
            </Poptip>
        </div>
      <div class="list-box">
        <div
          v-if="['all', 'image', 'video'].includes(current_tab) && infiniteList.length"
          class="masonry-container"
          style="margin-top: 30px; padding-bottom: 70px"
        >
          <masonry
            :cols="{ default: 6, 1700: 5, 1600: 5, 1500: 5, 1400: 4, 1300: 4 }"
            :gutter="{
              default: '30px',
              1700: '20px',
              1600: '20px',
              1500: '20px',
              1400: '20px',
              1300: '20px',
            }"
          >
            <div
              v-for="(item, index) in infiniteList"
              :key="index"
              @click="onArticleDetail(item)"
            >
              <template>
                <div class="masonry-item">
                  <img
                    v-if="item.type == 2"
                    src="../../assets/images/icon-play.png"
                    style="
                      width: 30px;
                      height: 30px;
                      position: absolute;
                      top: 10px;
                      right: 10px;
                      z-index: 10;
                    "
                    alt=""
                  />
                  <div class="image-container">
                    <img
                      :src="item.cover"
                      @load="onImageLoad"
                      class="masonry-image"
                    />
                  </div>
                  <div class="item-content">
                    <div class="title">{{ item.title }}</div>
                    <div class="bottom-box">
                      <div class="nick-avatar">
                        <img
                          class="avatar"
                          :src="item.member.avatar | default_img"
                        />
                        <div class="nick">
                          {{ item.member.nickname || item.member.username }}
                        </div>
                      </div>
                      <div class="like-box">
                        <img
                          src="../../assets/images/icon-like.png"
                          style="width: 16px; height: 16px"
                        />
                        <div style="margin-left: 3px">
                          {{ item.collect_count || 0 }}
                        </div>
                      </div>
                    </div>
                    <!-- <p>{{ item.description }}</p> -->
                  </div>
                </div>
              </template>
            </div>
          </masonry>
        </div>
        <div class="design-list" v-else-if="current_tab === 'design' && infiniteList.length">
          <div class="list-item" v-for="(item,index) in infiniteList" :key="index" @click="$router.push({name:'ProductDetail',query:{uuid:item.uuid}})">
            <img :src="item.cover | default_img" alt="" />
            <div class="content-box">
              <div class="title">{{item.name}}</div>
              <div class="cate">{{item.product_category_name}}</div>
              <div class="desc">
                {{ item.description }}
              </div>
              <div class="time">{{item.create_time}}</div>
            </div>
          </div>
        </div>
        <div class="user-list" v-else-if="current_tab === 'user' && infiniteList.length">
          <div class="follow-box">
            <div
              class="list-item"
              v-for="(item, index) in infiniteList"
              :key="`follow-${index}`"
            >
              <img
                @click="
                  $router.push({
                    name: 'UserProfile',
                    params: { code: item.code },
                  })
                "
                :src="item.avatar | default_img"
              />
              <div class="nickname">{{ item.nickname || item.username }}</div>
              <div class="job-city">
                {{ item.job }} <span v-if="item.job && item.city">|</span>
                {{ item.city || "地球" }}
              </div>
              <div class="user-data">
                <div class="item">
                  <div class="num">{{ item.create_num }}</div>
                  <div class="item-title">笔记</div>
                </div>
                <div class="item">
                  <div class="num">{{ item.design_num }}</div>
                  <div class="item-title">款式创建</div>
                </div>
                <div class="item">
                  <div class="num">{{ item.fans_num }}</div>
                  <div class="item-title">粉丝</div>
                </div>
              </div>
              <div class="btn-follow" v-if="!item.need_follow">
                <div class="btn-text">已关注</div>
                <Poptip placement="bottom" trigger="hover">
                  <template #content>
                    <div class="btn-menu">
                      <div
                        class="menu-item"
                        @click="onFollowUser(item.id, index)"
                      >
                        <div class="btn-text">取消关注</div>
                        <img src="../../assets/images/icon-list-cancel.png" />
                      </div>
                    </div>
                  </template>
                  <div class="btn-icon"></div>
                </Poptip>
              </div>
              <div
                class="btn-unfollow"
                v-else
                @click="onFollowUser(item.id, index)"
              >
                关注
              </div>
            </div>
          </div>
        </div>
        <div class="empty-container" v-else>
            <div class="empty-icon"></div>
            <div class="result-text">没有搜索到相关信息</div>
            <div class="result-tips">换个关键词再试一下吧~</div>
        </div>
      </div>
    </div>
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="uuid"
    ></ArticleDetail>
  </div>
</template>
<script>
import infiniteMixin from "@/mixins/infinite";
import ArticleDetail from "@/components/ArticleDetail";
import { SearchResult } from "@/api/index"
import { FollowUser } from "@/api/social";
export default {
  data() {
    return {
      query: {
        keyword: "",
        sort:'complex'
      },
      tabs: [
        { name: "全部", value: "all" },
        { name: "图文", value: "image" },
        { name: "视频", value: "video" },
        { name: "款式设计", value: "design" },
        { name: "用户", value: "user" },
      ],
      current_tab: "all",
      uuid: "",
      show_detail: false,
    };
  },
  watch:{
    current_tab(news,olds){
        if(news != olds){
            this.getInfiniteList(true);
        }
    },
    '$route'() {
        this.query.keyword = this.$route.params.keyword;
        this.getInfiniteList(true);
    },
    'query.sort'(news,olds){
        if(news != olds){
            this.getInfiniteList(true);
        }
    }
  },
  components: {
    ArticleDetail,
  },
  mixins: [infiniteMixin],
  mounted() {
    const { keyword } = this.$route.params;
    window.addEventListener("scroll", this.handleScroll);
    this.query.keyword = keyword;
    this.getInfiniteList(true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onReachBottom:_.debounce(function(){
      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;
        console.log('offsetBottom',offsetBottom);
        if (offsetBottom <= 500) {
          if (this.loadingMore || this.infiniteEnded || this.first_loading) return;
          console.log('触发触底加载...',new Date().getTime());
          this.loadingMore = true;
          this.getInfiniteList().finally(() => {
            this.loadingMore = false;
          });
        }
      });
    },100),
    handleScroll() {
      this.onReachBottom();
    },
    async onFollowUser(id, index) {
      try {
        const {type} = this;
        const need_follow = this.infiniteList[index].need_follow;
        const follow_each = this.infiniteList[index].follow_each;
        if(!need_follow){
            this.$DModal.confirm({
                content: '确认取消关注么?',
                onOK: async () => {
                    await FollowUser({ follow_id: id });
                    this.$set(this.infiniteList[index], "need_follow", !need_follow);
                    this.$layer.msg("操作成功");
                }
            })
        }else{
            await FollowUser({ follow_id: id });
            this.$set(this.infiniteList[index], "need_follow", !need_follow);
            this.$layer.msg("操作成功");
        }
      } catch (e) {
        console.log("e", e);
        this.$layer.msg("操作失败");
      }
    },
    onArticleDetail(data) {
      console.log("data---", data);
      this.uuid = data.uuid;
      this.show_detail = true;
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    onCloseArticleDetail() {
      this.show_detail = false;
    },
    async getInfiniteData(pageIndex, pageSize) {
        const {query,current_tab} = this;
        const { keyword,sort } = query;
        console.log("keyword", keyword);
        const res = {};
        const {data} = await SearchResult({keyword,page:pageIndex,limit:pageSize,type:current_tab,sort});
        res.data = data.length ? data : [];
    //   if(['all','image','video'].includes(this.current_tab)){
    //     res.data = [
    //     {
    //       id: "1",
    //       cover:
    //         "https://img1.baidu.com/it/u=3545181216,1426059705&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
    //       title: "标题",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 1,
    //     },
    //     {
    //       id: "2",
    //       cover:
    //         "https://pic.rmb.bdstatic.com/bjh/250214/dump/269069d8f9febadabd821acd1ccfddaa.png",
    //       title: "标题1",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 1,
    //     },
    //     {
    //       id: "3",
    //       cover:
    //         "https://q8.itc.cn/images01/20250205/baca697437d54d9bb8f3e444b3dccabe.jpeg    ",
    //       title: "标题2",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 2,
    //     },
    //     {
    //       id: "4",
    //       cover:
    //         "https://n.sinaimg.cn/sinakd20123/0/w2048h1152/20250218/6a5e-9d60a837ad6c6a8494fe485e9e70e596.jpg",
    //       title: "标题3",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 1,
    //     },
    //     {
    //       id: "5",
    //       cover:
    //         "https://pic.rmb.bdstatic.com/bjh/250214/dump/269069d8f9febadabd821acd1ccfddaa.png",
    //       title: "标题1",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 2,
    //     },
    //     {
    //       id: "6",
    //       cover:
    //         "https://q8.itc.cn/images01/20250205/baca697437d54d9bb8f3e444b3dccabe.jpeg    ",
    //       title: "标题2",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 2,
    //     },
    //     {
    //       id: "7",
    //       cover:
    //         "https://n.sinaimg.cn/sinakd20123/0/w2048h1152/20250218/6a5e-9d60a837ad6c6a8494fe485e9e70e596.jpg",
    //       title: "标题3",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 1,
    //     },
    //     {
    //       id: "8",
    //       cover:
    //         "https://pic.rmb.bdstatic.com/bjh/250214/dump/269069d8f9febadabd821acd1ccfddaa.png",
    //       title: "标题1",
    //       member: { nickname: "", username: "", avatar: "" },
    //       views_count: 0,
    //       comment_count: 0,
    //       zan_count: 0,
    //       type: 1,
    //     },
    //   ];
    //   }else{
    //     res.data = [
    //     {
    //             "id": 3,
    //             "username": "yzl",
    //             "nickname": null,
    //             "avatar": "http:\/\/img.hongli.xingjuju.com\/upload\/file\/template\/20250206\/384ee7534851d0ea202bc624c9c57d35.jpeg",
    //             "mobile": "15605001975",
    //             "create_time": "2024-11-30 16:14:02",
    //             "update_time": "2025-05-09 15:10:06",
    //             "delete_time": null,
    //             "status": 0,
    //             "sex": 2,
    //             "birthday": "2024-12-13",
    //             "province": "福建省",
    //             "city": "泉州市",
    //             "zone": "丰泽区",
    //             "code": "1166",
    //             "job": null,
    //             "create_num": 1,
    //             "design_num": 1,
    //             "fans_num": 1
    //         },
    //         {
    //             "id": 4,
    //             "username": "wzq",
    //             "nickname": "",
    //             "avatar": "",
    //             "mobile": "18260632418",
    //             "create_time": "2024-12-30 16:12:05",
    //             "update_time": "2025-05-08 09:06:06",
    //             "delete_time": null,
    //             "status": 0,
    //             "sex": 1,
    //             "birthday": "",
    //             "province": "",
    //             "city": "",
    //             "zone": "",
    //             "code": "2984",
    //             "job": null,
    //             "create_num": 5,
    //             "design_num": 0,
    //             "fans_num": 2
    //         },
    //         {
    //             "id": 12,
    //             "username": "18556811564",
    //             "nickname": "TS_yVsaeDfjiirHkzjm",
    //             "avatar": "http:\/\/img.hongli.xingjuju.com\/upload\/file\/template\/20250430\/4fbc7e3546ddaae0ff8a80039cdce2f9.jpeg",
    //             "mobile": "18556811564",
    //             "create_time": "2025-04-29 19:57:42",
    //             "update_time": "2025-04-30 09:31:19",
    //             "delete_time": null,
    //             "status": 0,
    //             "sex": 1,
    //             "birthday": "2025-04-24",
    //             "province": "福建省",
    //             "city": "泉州市",
    //             "zone": "丰泽区",
    //             "code": "0066",
    //             "job": null,
    //             "create_num": 0,
    //             "design_num": 0,
    //             "fans_num": 1
    //         }
    //     ]
    //   }

        return res;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./result.scss";
</style>
